import cn from '../../utils/cn';

export type FilterTabOption<T extends string = string> = {
  key: T;
  label: string;
  count?: number;
};

type Props<T extends string = string> = {
  options: FilterTabOption<T>[];
  active: T;
  onChange: (key: T) => void;
  className?: string;
};

export function FilterTabs<T extends string>({
  options,
  active,
  onChange,
  className,
}: Props<T>) {
  return (
    <div className={cn('flex gap-1 border-b border-neutral-200 pb-2', className)}>
      {options.map(({ key, label, count }) => (
        <button
          key={key}
          type="button"
          onClick={() => onChange(key)}
          className={cn(
            'px-3 py-1.5 text-lg rounded-md',
            active === key
              ? 'bg-neutral-100 text-neutral-800 font-medium'
              : 'text-neutral-500 hover:bg-neutral-50',
          )}
        >
          {label}
          {count !== undefined ? ` (${count})` : ''}
        </button>
      ))}
    </div>
  );
}
